import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Footer } from '@one-of-one/footer';
import {
  CalendarIcon,
  PinIcon,
  ArrowRightIcon,
  UserIcon,
  GroupIcon,
} from '@one-of-one/icons';

@Component({
  selector: 'app-home',
  imports: [Footer, CalendarIcon, PinIcon, ArrowRightIcon, UserIcon, GroupIcon],
  templateUrl: './home.html',
})
export class Home {
  private readonly router = inject(Router);

  redirectTo(toSingle: boolean) {
    const route = toSingle ? '/single-registration' : '/group-registration';
    this.router.navigate([route]);
  }
}
